import { render, staticRenderFns } from "./IonChannels.vue?vue&type=template&id=1f95bf50&"
import script from "./IonChannels.vue?vue&type=script&lang=js&"
export * from "./IonChannels.vue?vue&type=script&lang=js&"
import style0 from "./IonChannels.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports